// Authentication utility functions
// Self-hosted credentials authentication (email + password)

import { buildApiUrl, secureFetch } from "./queryClient";

export function isUnauthorizedError(error: Error): boolean {
  return /^401/.test(error.message) || /Unauthorized/.test(error.message);
}

export function redirectToLogin() {
  window.location.href = "/login";
}

export async function logout() {
  try {
    const response = await secureFetch(buildApiUrl("/api/auth/logout"), {
      method: "POST",
      credentials: "include",
    });
    if (response.ok) {
      window.location.href = "/";
    } else {
      window.location.href = buildApiUrl("/api/logout");
    }
  } catch {
    window.location.href = buildApiUrl("/api/logout");
  }
}

export async function login(email: string, password: string): Promise<{ success: boolean; message?: string; user?: any }> {
  const response = await secureFetch(buildApiUrl("/api/auth/login"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password }),
    credentials: "include",
  });
  return response.json();
}

export async function register(data: {
  email: string;
  password: string;
  firstName?: string;
  lastName?: string;
  accessKey?: string;
}): Promise<{ success: boolean; message?: string; user?: any }> {
  const response = await secureFetch(buildApiUrl("/api/auth/register"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
    credentials: "include",
  });
  return response.json();
}

export async function forgotPassword(email: string): Promise<{ success: boolean; message?: string }> {
  const response = await secureFetch(buildApiUrl("/api/auth/forgot-password"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email }),
    credentials: "include",
  });
  return response.json();
}

export async function resetPassword(token: string, password: string): Promise<{ success: boolean; message?: string }> {
  const response = await secureFetch(buildApiUrl("/api/auth/reset-password"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ token, password }),
    credentials: "include",
  });
  return response.json();
}
